import { render } from "./app-layout-shell.vue?vue&type=template&id=dc138662"
import script from "./app-layout-shell.vue?vue&type=script&lang=js"
export * from "./app-layout-shell.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__